import React, {Component} from 'react';
import Header from "./Header";
import AppNavbar from "./Sidebar";
import Favicon from "react-favicon";
import MetaTags from "react-meta-tags";
import axios from "axios";
import 'react-data-table-component-extensions/dist/index.css';

export default class C260MonthlySummary extends Component {


    constructor (props) {
        super(props)
        this.state = {
            loggedInUser:null,
            fromDate: '',
            toDate: '',
            userId: '',
            disabled : false,
            userViewInfo: []
        };
        this.handleToUserId = this.handleToUserId.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFromDate = this.handleFromDate.bind(this);
        this.handleToDate = this.handleToDate.bind(this);
    }

    componentDidMount() {

        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {

                this.setState({ loggedInUser: response.data })
                console.log("=== LOG_1 === Inside componentDidMount %s with data ","ACH Terminal",this.state.loggedInUser);
                //Get Terminal Ids


            }).finally(()=> {
            axios.get('getUserViewList?id='+this.state.loggedInUser)
                .then(response => {
                    this.setState({ userViewInfo: response.data.response,loading: false })
                }).finally(()=> {
            })
                .catch(error => {
                    console.log("Exception Thrown::{ get Terminal details by ID}",error);
                });
        })
            .catch(error => {
                console.log("GOT ERROR HERE for Get LoggedIn User",error);
            });


    }

    handleToUserId(event) {
        console.log("Changed Value for user-----",event.target.value)
        this.setState({
            userId: event.target.value
        });
    }

    handleFromDate(event) {
        console.log("Changed Value for Date-----",event.target.value)
        this.setState({
            fromDate: event.target.value
        });
    }

    handleToDate(event) {
        console.log("Changed Value -----",event.target.value)
        this.setState({
            toDate: event.target.value
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        let userDetailID= '';
        console.log(this.state.fromDate,"FromDate ---- ----Todate ------userid ",this.state.toDate,this.state.userId);
        if(this.state.fromDate === '' || this.state.toDate === ''){
            alert(" Please provide valid  Date !!")
            return false;
        }
        if (this.state.disabled) {
            return;
        }
        this.setState({disabled: true});
        console.log(this.state.userId  === '' )

        if (this.state.userId === undefined || this.state.userId === null || this.state.userId  === '') {
            userDetailID = this.state.loggedInUser;
        }else{
            userDetailID = this.state.userId;
        }
        console.log(this.state.userId)
        console.log(userDetailID)
        axios({
            url: 'downloadC260MonthlySummaryReport?fromDate='+this.state.fromDate+"&toDate="+this.state.toDate+"&userID="+userDetailID, //your url
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'C260MonthlySummary.xls'); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.setState({disabled: false});
        });
        this.setState({disabled: false});
    }

    render() {

        const alignBox = {
            display: "flex",
            justifyContent: "space-around"
        };

        const terminalList = this.state.userViewInfo.map((i) => {
            return <option value={i.userId}>{i.userId}</option>;
        });
        terminalList.unshift(<option value={this.state.loggedInUser}>{this.state.loggedInUser}</option>)

        return (
            <body data-sidebar="colored">
            <div id="layout-wrapper">
                <Header/>
                <AppNavbar data={this.state}/>
            </div>
            <div className="main-content">
                <Favicon url='https://passporttechnology.com/images/base/favicon-16x16.png' />
                <MetaTags>
                    <title>DataStream Version 2.0</title>
                    <meta name="description" content="DataStream Version 2.0" />
                    <meta property="og:title" content="DataStream Version 2.0" />
                </MetaTags>
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">Report Management</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-9">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="tab-content p-3 text-muted">
                                            <div className="form-group">
                                                <form onSubmit={ this.handleSubmit }>
                                                    <div className="form-group" style={alignBox}>
                                                        <div>

                                                            <label className="control-label">User Id: </label>
                                                            <select name="userId" id="userId" className="custom-select" onChange={this.handleToUserId} >
                                                                {terminalList}
                                                            </select>
                                                        </div>
                                                        <div>
                                                            <label  className="control-label">From Date: </label>
                                                            <input type="date" id="fromDate" className="custom-select" style={{ background: "content-box"}} onChange={this.handleFromDate}/>
                                                        </div>
                                                        <div>
                                                            <label  className="control-label">To Date: </label>
                                                            <input type="date" id="toDate" className="custom-select" style={{ background: "content-box"}} onChange={this.handleToDate}/>
                                                        </div>

                                                    </div>
                                                    <div>
                                                        <button className="btn btn-primary" onClick={this.handleClick} disabled={this.state.disabled} >Generate Report</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </body>
        );
    }
}